import axios from 'axios';
import Token from './token';
import { jwtDecode } from 'jwt-decode';


let token = '';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_API,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Authorization',
    'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
  },
});

api.interceptors.request.use(
  async (request) => {
    const agora = Math.floor(Date.now() / 1000); // segundos

    // Ignora URLs do id.ms.gov.br
    if (!request.url?.includes('id.ms.gov.br')) {
      let storedToken = sessionStorage.getItem('Token');
      let precisaRenovar = true;
      if (storedToken) {
        try {
           const decoded = jwtDecode(storedToken);
          // Se expirar em mais de 60s, mantém
          if (decoded?.exp && decoded.exp > agora + 60) {
            precisaRenovar = false;
          }
        } catch {
          precisaRenovar = true;
        }
      }     

      if (precisaRenovar) {
        token = await Token();
        storedToken = token;
      }

      if (storedToken) {
        request.headers['Authorization'] = `Bearer ${storedToken}`;
      }
    }

    return request;
  },
  (error) => Promise.reject(error)
);

export default api;
